import { render, staticRenderFns } from "./ApplicationEW.vue?vue&type=template&id=bbfad3fe&"
import script from "./ApplicationEW.vue?vue&type=script&lang=js&"
export * from "./ApplicationEW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports